import React, { useEffect } from 'react';
import { Toaster, toast as hotToast } from 'react-hot-toast';
import { useAppStore } from '@/stores/appStore';

export const Toast: React.FC = () => {
  const { notifications } = useAppStore();

  useEffect(() => {
    // Sync notifications with react-hot-toast
    notifications.forEach((notification) => {
      if (notification.type === 'success') {
        hotToast.success(notification.message || notification.title, {
          id: notification.id,
          duration: notification.duration,
        });
      } else if (notification.type === 'error') {
        hotToast.error(notification.message || notification.title, {
          id: notification.id,
          duration: notification.duration,
        });
      } else if (notification.type === 'warning') {
        hotToast(notification.message || notification.title, {
          id: notification.id,
          duration: notification.duration,
          icon: '⚠️',
        });
      } else {
        hotToast(notification.message || notification.title, {
          id: notification.id,
          duration: notification.duration,
        });
      }
    });
  }, [notifications]);

  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 5000,
        style: {
          background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
          color: '#fff',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
        },
        success: {
          style: {
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          },
        },
        error: {
          style: {
            background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
          },
        },
      }}
    />
  );
};
